import NAME from "./constants";

export const getNewsDialogIsVisited = store => store[NAME].newsDialogIsVisited;
export const getIsLoading = store => store[NAME].isLoading;
export const getCounters = store => store[NAME].counters;
export const getDownloads = store => store[NAME].downloads;
export const getLinks = store => store[NAME].links;
export const getModal = store => store[NAME].modal;
export const getNews = store => store[NAME].news;
export const getPolls = store => store[NAME].polls;